// Pure helpers for the Email inbox (spec 2026-10-02 Phase 2).

export type FilterField = 'from_address' | 'from_domain' | 'subject_contains'

/** What a filtered row carries about the rule that caught it. */
export type FilterRuleRef = { id: number; field: FilterField; value: string }

/** A rule as the Settings list returns it. */
export type FilterRule = FilterRuleRef & {
  note: string | null; created_by: string; created_at: string | null
}

export const FIELD_LABELS: Record<FilterField, string> = {
  from_address: 'from address', from_domain: 'from domain', subject_contains: 'subject contains',
}

const BUILT_IN: Record<string, string> = {
  auto_reply: 'Automatic reply', spam: 'Spam', our_own_mail: 'Our own mail',
}

/** Why a message sits in Filtered. `filterRule` is the API's `filter_rule`
 *  (null once the rule is deleted). */
export function filteredLabel(reason: string | null, filterRule: FilterRuleRef | null): string {
  if (!reason) return ''
  if (BUILT_IN[reason]) return BUILT_IN[reason]
  const m = /^rule:(\d+)$/.exec(reason)
  if (!m) return reason
  return filterRule
    ? `Rule: ${FIELD_LABELS[filterRule.field] ?? filterRule.field} ${filterRule.value}`
    : `Rule #${m[1]} (deleted)`
}

export function identityNote(identity: 'verified' | 'unverified'): string | null {
  return identity === 'unverified' ? "Sender not verified: the reply won't include account details." : null
}

/** A ?message= deep link that isn't in the loaded Inbox page is probably
 *  filtered: say whether to look in the Filtered tab (once). */
export function shouldTryFiltered(
  linked: number | null, tab: 'inbox' | 'filtered', loaded: boolean,
  ids: number[], alreadyTried: boolean,
): boolean {
  return linked !== null && tab === 'inbox' && loaded && !alreadyTried && !ids.includes(linked)
}

/** "Name <address>" for the list row. The address is always shown: a display
 *  name is chosen by the sender and can impersonate someone ("victim@gmail.com"). */
export function senderLabel(name: string | null, address: string): string {
  const n = (name ?? '').trim()
  if (!n || n.toLowerCase() === address.trim().toLowerCase()) return address
  return `${n} <${address}>`
}
